// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hgDc","input":"styles_input__3SkV6"};